import { useEffect, useRef, useState } from "react";
import "./style.css";
import { ROUTES } from "router/types";

const containerStyles: React.CSSProperties = {
  display: "flex",
  position: "fixed",
  right: "0",
  bottom: "30%",
  zIndex: 5,
};

const feedbackDivStyles: React.CSSProperties = {
  height: "92px",
  width: "36px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "0",
  background: "linear-gradient(90deg, #024b7e 0%, #2e9ae5 100%)",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  borderRadius: "4px 0 0 4px",
  cursor: "pointer",
};

const contactDivStyles: React.CSSProperties = {
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 0px",
  border: "1px solid #2081c4",
  background: "#F8F8F8",
};

const baseTextStyles: React.CSSProperties = {
  fontFamily: "Lato",
  fontStyle: "normal",
};

const feedbackDivTextStyles: React.CSSProperties = {
  ...baseTextStyles,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.4px",
  color: "#ffffff",
  transform: "rotate(-90deg)",
};

const contactDivTextStyles: React.CSSProperties = {
  ...baseTextStyles,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#424242",
  animation: "fadeIn 1s ease-in-out forwards",
  padding: "0px 20px",
  textDecoration: "none",
};

function Popover() {
  const feedbackBoxRef = useRef<HTMLDivElement>(null);
  const contactBoxRef = useRef<HTMLDivElement>(null);

  const [isExtended, setIsExtended] = useState<boolean>(false);

  const handleDivClick = () => {
    setIsExtended(true);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (
      contactBoxRef.current &&
      !contactBoxRef.current.contains(event.target as Node)
    ) {
      setIsExtended(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div style={containerStyles}>
      {window.location.pathname !== ROUTES.CreateAccount &&
        window.location.pathname !== ROUTES.ForgotPassword && (
          <div
            style={feedbackDivStyles}
            onClick={handleDivClick}
            ref={feedbackBoxRef}
          >
            <p style={feedbackDivTextStyles}>Feedback</p>
          </div>
        )}
      {isExtended && (
        <div style={contactDivStyles} ref={contactBoxRef}>
          <a
            href="mailto:contact@ridgewood-partners.com"
            style={contactDivTextStyles}
            onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) =>
              (e.currentTarget.style.color = "#09578e")
            }
            onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) =>
              (e.currentTarget.style.color = "#424242")
            }
          >
            contact@ridgewood-partners.com
          </a>
        </div>
      )}
    </div>
  );
}

export default Popover;
